// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3L5-R","range":"MonthRangeSwitch_range__1nn_r","disabled":"MonthRangeSwitch_disabled__1nNxT"};